import { getRoutePathWithId } from '@/utils/router-utils';

export const SELL_PREFIX = 'sell';
export const BUY_PREFIX = 'buy';
export const ADMIN_PREFIX = 'admin';
export const ACCOUNT_PREFIX = 'account';
export const BULK_UPLOAD_PREFIX = 'inventory/upload';

export class RoutePaths {
  static ROOT = '';
  static ACTIVATION = 'activation'; // TODO: pluralize
  static ACTIVATION_DETAIL = 'activation/:id'; // TODO: pluralize
  static ARTISTS = 'artists';
  static ARTISTS_CREATE = 'artists/create';
  static ARTISTS_DETAIL = 'artists/:id';
  static ARTISTS_EDIT = 'artists/:id/edit';
  static ARTISTS_DETAIL_GALLERY = 'galleries/:galleryId';
  static ARTISTS_DETAIL_ARTWORK = 'artworks/:artworkId';
  static INVENTORY = 'inventory';
  static INVENTORY_CREATE = 'inventory/create';
  static INVENTORY_DETAIL = 'inventory/:id';
  static INVENTORY_EDIT = 'inventory/:id/edit';
  static DASHBOARD = 'dashboard';
  static BULK_UPLOAD_PREVIEW = 'preview';
  static BULK_UPLOAD_CONNECT_ARTISTS = 'connect-artists';
  static BULK_UPLOAD_SELECT = 'select';
  static BULK_UPLOAD_REVIEW = 'review';
  static BULK_UPLOAD_DONE = 'done';
  static PREFERENCES = 'preferences';
  static SETTINGS = 'settings';
  static PAYMENTS = 'payments';
  static MY_SETTINGS = 'my-settings';
  static SUBSCRIPTION = 'subscription';
  static PROFILE_EDIT = 'profile/edit';
  static INVITATIONS = 'invitation/:id';
  static QR_LABEL = {
    STOREFRONT: 'qr-label/storefronts/:id',
    EXHIBITOR: 'qr-label/exhibitors/:id',
    LISTING: 'qr-label/listings/:id',
    ARTWORK_LISTING: 'qr-label/listings/:id/:artworkId',
  };
  static SELLER = 'sellers/:id';
  static LISTINGS = 'listings/:id';

  static PAYMENT_ONBOARDING = 'profile/payment-info';
  static SELL = {
    REQUESTS: `${SELL_PREFIX}/requests`,
    REQUEST_DETAIL: `${SELL_PREFIX}/requests/:id`,
    SALES_AGREEMENT: `${SELL_PREFIX}/sales-agreements`,
    SALES_AGREEMENT_DETAILS: `${SELL_PREFIX}/sales-agreements/:id`,
    SALES_AGREEMENT_CREATE: `${SELL_PREFIX}/sales-agreements/create`,
    SALES_AGREEMENT_DETAIL: `${SELL_PREFIX}/sales-agreements/:id`,
    TRANSFER_CREATE: `${SELL_PREFIX}/sales-agreements/create-transfer`,
    TRANSFER_DETAILS: `${SELL_PREFIX}/transfers/:id`,
  };
  static BUY = {
    REQUESTS: `${BUY_PREFIX}/requests`,
    REQUEST_DETAIL: `${BUY_PREFIX}/requests/:id`,
    SALES_AGREEMENT: `${BUY_PREFIX}/sales-agreements`,
    SALES_AGREEMENT_DETAILS: `${BUY_PREFIX}/sales-agreements/:id`,
    TRANSFER_DETAILS: `${BUY_PREFIX}/transfers/:id`,
  };
  static ADMIN = {
    EMAILS: `${ADMIN_PREFIX}/emails`,
    USER_ACCESS: `${ADMIN_PREFIX}/user-access`,
    ID_SCANNER: `${ADMIN_PREFIX}/id-scanner`,
  };
  static ACCOUNT = {
    ROOT: ACCOUNT_PREFIX,
    PREFERENCES: `${ACCOUNT_PREFIX}/${RoutePaths.PREFERENCES}`,
    SETTINGS: `${ACCOUNT_PREFIX}/${RoutePaths.SETTINGS}`,
    MY_SETTINGS: `${ACCOUNT_PREFIX}/${RoutePaths.MY_SETTINGS}`,
    PAYMENTS: `${ACCOUNT_PREFIX}/${RoutePaths.PAYMENTS}`,
    SUBSCRIPTION: `${ACCOUNT_PREFIX}/${RoutePaths.SUBSCRIPTION}`,
    TEAM: `${ACCOUNT_PREFIX}/team`,
  };

  static BULK_UPLOAD = {
    ROOT: BULK_UPLOAD_PREFIX,
    PREVIEW: `${BULK_UPLOAD_PREFIX}/${RoutePaths.BULK_UPLOAD_PREVIEW}`,
    CONNECT_ARTISTS: `${BULK_UPLOAD_PREFIX}/${RoutePaths.BULK_UPLOAD_CONNECT_ARTISTS}`,
    SELECT: `${BULK_UPLOAD_PREFIX}/${RoutePaths.BULK_UPLOAD_SELECT}`,
    REVIEW: `${BULK_UPLOAD_PREFIX}/${RoutePaths.BULK_UPLOAD_REVIEW}`,
    DONE: `${BULK_UPLOAD_PREFIX}/${RoutePaths.BULK_UPLOAD_DONE}`,
  };

  static ORGANIZATIONS = 'organizations';

  static GALLERY_PROFILE = {
    PROFILE: 'gallery-profile/:id',
    EXHIBITIONS: 'gallery-profile/:id/exhibitions',
    FAIRS: 'gallery-profile/:id/fairs',
    ARTISTS: 'gallery-profile/:id/artists',
    TEAM: 'gallery-profile/:id/team',
    LOCATIONS: 'gallery-profile/:id/locations',
    BILLING: 'gallery-profile/:id/billing',
    PRESS: 'gallery-profile/:id/press',
  };
}

export const getRoute = (path: string, id?: string) => {
  const fullPath = `${RoutePaths.ROOT}/${path}`;
  if (id) {
    return getRoutePathWithId(fullPath, id);
  }
  return fullPath;
};
